import Image from 'next/image'
import { CertificateSource } from 'containers/calculator/entities/discounts'
import { useCalculatorInput } from 'containers/calculator/hooks/useCalculatorInput'
import style from 'containers/calculator/styles/components/discountSelector.module.css'
import BCorpLogo from 'public/img/ESGCertificates/b_corp_white.svg?url'
import ClimateNeutralLogo from 'public/img/ESGCertificates/climate_neutral_white.svg?url'
import OnePercentLogo from 'public/img/ESGCertificates/one_percent_white.svg?url'
import PlanetMarkLogo from 'public/img/ESGCertificates/planet_mark_white.svg?url'
import CheckIcon from 'public/img/check.svg'

const certificateOptions: { value: CertificateSource; img: any }[] = [
    {
        img: () => (
            <Image
                src={PlanetMarkLogo}
                className={style['planet-mark-logo']}
                width={70}
                height={30}
                alt="icon"
            />
        ),
        value: 'PLANET_MARK',
    },
    {
        img: () => (
            <Image
                src={OnePercentLogo}
                className={style['one-percent-logo']}
                width={70}
                height={30}
                alt="icon"
            />
        ),
        value: 'ONE_PERCENT_FOR_THE_PLANET',
    },
    {
        img: () => <Image src={BCorpLogo} width={110} height={30} alt="icon" />,
        value: 'B_CORP',
    },
    {
        img: () => <Image src={ClimateNeutralLogo} width={100} height={30} alt="icon" />,
        value: 'CLIMATE_NEUTRAL',
    },
]

const CertificateInput = ({
    img: Img,
    value,
    onChange,
    checked,
}: {
    img: any
    value: string
    onChange: () => void
    checked?: boolean
}) => {
    return (
        <div className={style['certificate-input']}>
            <input
                type="checkbox"
                id={value}
                value={value}
                name="certificates"
                checked={checked}
                onChange={onChange}
            />
            <label htmlFor={value}>
                <Img />
                <span>
                    <CheckIcon className="check-icon" />
                </span>
            </label>
        </div>
    )
}

export const DiscountSelector = () => {
    const { values, setValues } = useCalculatorInput()

    const toggleSelection = (value: CertificateSource) => {
        const updatedItems = [...values.discounts]
        const isSelected = updatedItems.some(item => item.name === value)
        if (isSelected) {
            const index = updatedItems.findIndex(item => item.name === value)
            updatedItems.splice(index, 1)
        } else {
            updatedItems.push({
                name: value,
            })
        }
        setValues({ ...values, discounts: updatedItems })
    }

    const selectedDiscounts = values.discounts?.map(discount => discount.name)

    return (
        <div className={style['discount-container']}>
            <p>Claim your discounts</p>
            <div className={style['discount-selector']}>
                {certificateOptions.map(option => (
                    <CertificateInput
                        key={option.value}
                        img={option.img}
                        value={option.value}
                        onChange={() => toggleSelection(option.value)}
                        checked={selectedDiscounts.indexOf(option.value) >= 0}
                    />
                ))}
            </div>
        </div>
    )
}
